import { lazy, type ComponentType } from 'react';

type Importer<T extends Record<string, unknown>> = () => Promise<T>;

/**
 * Named export를 lazy하게 불러오는 헬퍼.
 * export 이름을 제네릭으로 고정해 오타를 컴파일 단계에서 잡는다.
 */
export function lazyNamed<M extends Record<string, ComponentType<any>>, K extends keyof M & string>(
  factory: Importer<M>,
  exportName: K,
) {
  return lazy(() =>
    factory().then((module) => {
      const component = module[exportName];

      if (!component) {
        throw new Error(`lazyNamed: ${exportName} 컴포넌트를 찾을 수 없습니다.`);
      }

      return { default: component };
    }),
  );
}

/**
 * default export용 헬퍼. 가독성을 위해 일관된 인터페이스를 제공한다.
 */
export function lazyDefault<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(factory);
}
